import { OnboardingFormFields } from '@Types/index.ts';
import i18next from '@in18/in18';
import { LiliPasswordInput } from '@lili/lili-frontend-common';
import { Controller } from 'react-hook-form';
import { z } from 'zod';

const MIN_PASS_CHARS = 8;
const MAX_PASS_CHARS = 20;
const { t } = i18next;

interface PasswordInputProps {
  disabled?: boolean;
  tabIndex?: number;
}

export const PasswordInput = ({ disabled, tabIndex }: PasswordInputProps) => {
  return (
    <Controller
      name={OnboardingFormFields.PASSWORD}
      render={({ field: { onBlur, onChange }, fieldState: { error } }) => (
        <LiliPasswordInput
          onChange={onChange}
          id={OnboardingFormFields.PASSWORD}
          title={t('pages.home.password')}
          errorMessage={error?.message}
          onBlur={onBlur}
          passwordStrengthHints={[
            t('pages.home.passwordHints.minimumChars'),
            t('pages.home.passwordHints.uppercaseLetter'),
            t('pages.home.passwordHints.number'),
          ]}
          passwordStrengthTexts={{
            tooWeak: t('pages.home.passwordStrength.tooWeak'),
            weak: t('pages.home.passwordStrength.weak'),
            medium: t('pages.home.passwordStrength.medium'),
            strong: t('pages.home.passwordStrength.strong'),
          }}
          tabIndex={tabIndex}
          disabled={disabled}
        />
      )}
    />
  );
};

export const passwordScheme = z.object({
  [OnboardingFormFields.PASSWORD]: z
    .string()
    .trim()
    .min(MIN_PASS_CHARS, t('enErrors:password.min', { num: MIN_PASS_CHARS }))
    .max(MAX_PASS_CHARS, t('enErrors:password.max', { num: MAX_PASS_CHARS })),
});
